module.exports = __webpack_public_path__ + "static/media/EncodeSansCondensed-Medium.3c32f350.ttf";